import { useMemo } from 'react';

import { Alert } from 'ui';
import { IconInfo } from 'ui/Icons';

const EndedCampaignAlert = ({
  type,
  hiddenFrom,
}: {
  type: 'campaign' | 'event';
  hiddenFrom?: 'sm' | 'md' | 'lg' | 'xl';
}) => {
  const message = useMemo(() => {
    if (type === 'campaign') {
      return 'This campaign is no longer accepting donations. To support this cause, check out their active campaigns on the Campaigns tab.';
    }
    return 'This ticketed event is no longer active. You can view other upcoming events on the Events tab of the cause page.';
  }, [type]);
  return (
    <Alert
      type="warning"
      title={`This ${type} has ended`}
      icon={<IconInfo />}
      hiddenFrom={hiddenFrom}
    >
      {message}
    </Alert>
  );
};

export { EndedCampaignAlert };
